const WindowFunctions = (message, func) => {
    if (!window.Pico) {
        window.Pico = {}
    }

    switch (message) {
        case 'REGISTER/FORM':
            window.Pico.handleFormSubmit = func
            break
        case 'REGISTER/MENU':
            window.Pico.handleMenuLinkClick = func
            break
        case 'REGISTER/PLAN_OPTION':
            window.Pico.handlePlanOptionLinkClick = func
            break
        case 'REGISTER/PROMPT':
            window.Pico.handlePromptClick = func
            break
        case 'REGISTER/CLOSE_PICO':
            window.Pico.handleEscapeClicked = func
            break
        case 'REGISTER/GET_LIFECYCLE_EVENTS':
            window.Pico.getLifecycleEvents = async (args) => func(args)
            break
        case 'REGISTER/POPUP':
            window.Pico.handlePopupClick = func
            break
        default:
    }
}

export default WindowFunctions
